import type { SiteCopy } from "./en";

export const pt = {
  nav: {
    links: [
      { href: "/availability-monitor", label: "Monitor" },
      { href: "/how-it-works", label: "Como funciona" },
      { href: "/routes", label: "Rotas" },
      { href: "/pricing", label: "Preço" },
      { href: "/blog", label: "Guias" },
    ],
    createNotification: "Criar alerta",
    dashboard: "Meus alertas",
    homeLabel: "Início da MachuPing",
    menuLabel: "Abrir menu",
    switchLanguage: "Português",
    switchLanguageHref: "/pt",
  },
  footer: {
    tagline: "Alertas de disponibilidade para rotas difíceis de Machu Picchu.",
    disclaimer: "Serviço independente. Apenas notificações; não revendemos ingressos.",
    rights: "Todos os direitos reservados.",
    columns: {
      Produto: [
        { href: "/availability-monitor", label: "Monitor de disponibilidade" },
        { href: "/ticket-alerts", label: "Alertas de ingressos" },
        { href: "/restock-alerts", label: "Alertas de reabertura" },
        { href: "/availability", label: "Alertas de disponibilidade" },
        { href: "/routes", label: "Rotas suportadas" },
        { href: "/how-it-works", label: "Como funciona" },
        { href: "/pricing", label: "Preço" },
      ],
      Recursos: [
        { href: "/blog", label: "Guias" },
        { href: "/faq", label: "Perguntas frequentes" },
        { href: "/trust", label: "Confiança e segurança" },
        { href: "/contact", label: "Contato" },
        { href: "/status", label: "Status do sistema" },
      ],
      Legal: [
        { href: "/privacy", label: "Privacidade" },
        { href: "/terms", label: "Termos" },
      ],
    },
  },
  home: {
    metadataTitle: "Alertas de ingressos para Machu Picchu",
    metadataDescription:
      "Receba alertas por email quando aparecer disponibilidade para Machu Picchu. Escolha datas exatas, rotas e tamanho do grupo; compre no fornecedor oficial.",
    badge: "Feito para dias esgotados",
    title: "Machu Picchu esgotou? Avisamos quando os ingressos voltarem.",
    description:
      "Cancelamentos e reaberturas acontecem o tempo todo. A MachuPing monitora suas datas e rotas exatas e envia um email assim que surgem vagas — você compra no fornecedor oficial.",
    heroCta: "Criar seu alerta",
    secondaryCta: "Ver rotas suportadas",
    stats: {
      routesMonitored: "Rotas monitoradas",
      notificationSpeed: "Velocidade do alerta",
      monitoring: "Monitoramento",
      openingsCaught: "Reaberturas capturadas (7d)",
      alertsSent: "emails enviados",
    },
    setupTitle: "Criar seu alerta",
    setupDescription: "Escolha rotas, datas e tamanho do grupo. Você revisa tudo antes de pagar.",
    setupCta: "Continuar",
    stepsTitle: "Como funciona",
    steps: [
      { step: "1", title: "Escolha suas rotas", description: "Selecione todas as rotas e horários que você aceitaria." },
      { step: "2", title: "Defina preferências", description: "Adicione datas exatas e tamanho do grupo, depois pague a partir de US$ 9." },
      { step: "3", title: "Receba o aviso e compre", description: "Avisamos assim que abrir — compre no fornecedor oficial." },
    ],
    fullFlow: "Ver o fluxo completo",
    whyBadge: "Por que MachuPing",
    whyTitle: "Feito para janelas curtas de disponibilidade",
    why: [
      { title: "Alertas rápidos por email", description: "Verificamos com frequência e avisamos em minutos quando aparece inventário compatível." },
      { title: "Exatamente o que você reservaria", description: "Escolha rotas, horários, datas e tamanho do grupo que aceitaria. Só alertamos em correspondências reais." },
      { title: "Apenas notificações", description: "Nunca seguramos nem revendemos ingressos. Você compra diretamente no fornecedor oficial." },
      { title: "A partir de US$ 9", description: "US$ 9 para um viajante, +US$ 3 por viajante adicional, até US$ 18. Pagamento único, sem assinatura." },
    ],
    proofTitle: "Veja funcionando agora",
    proofDescription: "Dados ao vivo do nosso monitor: reaberturas recentes, vagas atuais e últimas verificações.",
    bottomTitle: "Pare de atualizar. Comece a receber alertas.",
    bottomDescription: "Crie um alerta focado para suas rotas e datas, e deixe que monitoremos por você.",
    bottomCta: "Criar seu alerta",
    bottomSecondaryCta: "Ver preço",
  },
  alertSetup: {
    eyebrow: "Configure seu alerta",
    routesLabel: "Quais rotas servem para você?",
    selectAll: "Selecionar todas",
    clearAll: "Limpar tudo",
    selectGroup: "Selecionar todas",
    backupHint: "Escolha todas as rotas que você aceitaria — mais chances. Seguimos avisando até suas datas passarem ou você pausar.",
    editRoutes: "Editar rotas",
    hideRoutes: "Pronto",
    datesLabel: "Quando você quer ir?",
    datesHint: "Escolha sua data principal. Adicione alternativas se seus planos forem flexíveis: monitoramos todas as datas que você escolher.",
    travelDate: "Data da viagem",
    backupDate: "Data alternativa",
    addBackupDate: "Adicionar uma data alternativa",
    pickDate: "Escolha uma data",
    partyLabel: "Quantos ingressos?",
    partyHint: "Só avisamos quando esse número de vagas abrir junto.",
    setupSummary: "Seu alerta",
    routes: "Rotas",
    chooseRoute: "Escolha uma rota",
    party: "Ingressos",
    ticket: "ingresso",
    tickets: "ingressos",
    addPartySize: "Adicione o tamanho do grupo",
    dates: "Datas",
    chooseDate: "Adicione uma data",
    delivery: "Entrega",
    deliveryDetail: "Alertas por email depois do login",
    configured: "Tudo pronto — salve para começar a monitorar.",
    finishChoices: "Adicione uma data para começar.",
    chooseDateCta: "Escolha uma data para continuar",
    reviewBeforePayment: "Sem cobrança até você revisar e confirmar — depois a partir de US$ 9, sem assinatura.",
    askBeforeSignin: "Tem uma pergunta antes de entrar?",
    bookingTips: "Dicas para reservar assim que enviarmos o email",
    edit: "Editar",
    done: "Pronto",
    allRoutes: "Todas as rotas",
    routesSelected: "{count} rotas",
  },
  bookingReadiness: {
    title: "Prepare-se para comprar antes do alerta chegar",
    description: "As vagas podem desaparecer em minutos. Um pouco de preparo agora permite comprar assim que enviarmos o email.",
    guideCta: "Ler o checklist completo",
    steps: [
      "Crie ou acesse sua conta oficial da TuBoleto (tuboleto.cultura.pe) com antecedência.",
      "Verifique o email da conta para não travar no login.",
      "Tenha o passaporte e o nome completo de cada viajante à mão, além de um cartão válido.",
      "Quando nosso email chegar, abra o link de compra e pague imediatamente — o inventário pode sumir rápido.",
    ],
  },
  restockProof: {
    title: "Status do monitoramento",
    status: {
      operational: {
        label: "Ao vivo",
        headline: "Estamos procurando ingressos agora mesmo",
        sub: "As verificações estão funcionando normalmente. Você receberá um email assim que novas vagas abrirem.",
      },
      degraded: {
        label: "Com leve atraso",
        headline: "As verificações estão um pouco atrasadas",
        sub: "Continuamos monitorando, mas a última verificação é mais antiga que o normal — a disponibilidade abaixo pode ficar atrás do site oficial.",
      },
      stale: {
        label: "Se atualizando",
        headline: "Nossas verificações estão se atualizando",
        sub: "O monitoramento está atrasado por enquanto. Trate a disponibilidade abaixo como histórica até ele se atualizar.",
      },
      unknown: {
        label: "Iniciando",
        headline: "O monitoramento está sendo configurado",
        sub: "Nenhuma verificação foi concluída ainda. Confirme no site oficial antes de confiar nos dados abaixo.",
      },
    },
    lastCheckedPrefix: "Última verificação",
    metrics: {
      available: {
        label: "Horários monitorados com vagas",
        help: "Vagas que vemos neste momento nas datas que monitoramos.",
      },
      opened7d: {
        label: "Vezes que ingressos abriram",
        help: "Com que frequência novas vagas apareceram nos últimos 7 dias.",
      },
      lastOpened: {
        label: "Última vez que ingressos abriram",
        help: "Quando vimos novas vagas disponíveis pela última vez.",
      },
      lastChecked: {
        label: "Última verificação",
        help: "Quando olhamos o site oficial pela última vez.",
      },
    },
    slotsWithStock: "Horários monitorados com vagas",
    nearestTitle: "Ingressos que você pode garantir agora",
    nearestSub: "Vagas abertas que estamos vendo em próximas datas.",
    noCached: "Não há vagas abertas agora — avisaremos por email assim que aparecerem.",
    recentTitle: "Abertas recentemente",
    recentSub: "Novas vagas que detectamos há pouco.",
    opening: "abertura",
    openings: "aberturas",
    last24h: "nas últimas 24h",
    noIncreases: "Ainda não foram detectadas novas vagas.",
    noneYet: "Ainda nenhuma",
    starting: "Iniciando",
    seat: "vaga",
    seats: "vagas",
    at: "às",
    scope: "disponibilidade de Machu Picchu",
  },
  emails: {
    subject: "Disponibilidade para Machu Picchu: {date} {slot}",
    found: "A MachuPing encontrou disponibilidade.",
    route: "Rota",
    date: "Data",
    slot: "Horário",
    seatsObserved: "Vagas observadas",
    book: "Comprar no fornecedor oficial",
  },
} as const satisfies SiteCopy;
